import createIcon from '../../createIcon';

/**
 * @component @name AssignmentLate
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgNEgxNC44MkMxNC40IDIuODQgMTMuMyAyIDEyIDJDMTAuNyAyIDkuNiAyLjg0IDkuMTggNEg1QzMuOSA0IDMgNC45IDMgNlYyMEMzIDIxLjEgMy45IDIyIDUgMjJIMTlDMjAuMSAyMiAyMSAyMS4xIDIxIDIwVjZDMjEgNC45IDIwLjEgNCAxOSA0Wk0xMyAxOUgxMVYxN0gxM1YxOVpNMTMgMTVIMTFWOUgxM1YxNVpNMTIgNkMxMS40NSA2IDExIDUuNTUgMTEgNUMxMSA0LjQ1IDExLjQ1IDQgMTIgNEMxMi41NSA0IDEzIDQuNDUgMTMgNUMxMyA1LjU1IDEyLjU1IDYgMTIgNloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AssignmentLate = createIcon('AssignmentLate', [
  [
    'path',
    {
      d: 'M19 4H14.82C14.4 2.84 13.3 2 12 2C10.7 2 9.6 2.84 9.18 4H5C3.9 4 3 4.9 3 6V20C3 21.1 3.9 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM13 19H11V17H13V19ZM13 15H11V9H13V15ZM12 6C11.45 6 11 5.55 11 5C11 4.45 11.45 4 12 4C12.55 4 13 4.45 13 5C13 5.55 12.55 6 12 6Z',
      key: '10x3zs',
    },
  ],
]);

export default AssignmentLate;
